import { api } from 'services/api'

export async function fetchUsers() {
  const { data } = await api.get('/users')

  return data
}
